export default __webpack_public_path__ + "static/media/slideoneimg.e7755bf0.png";